export default {
  messages: (s) => s.messages,
  conversationId: (s) => s.conversationId,
  isSending: (s) => s.isSending,
  error: (s) => s.error,
  aiAccess: (s) => s.aiAccess,
};
